import {useMemo, useState} from 'react';

import type {CompanyWorkforceProfile} from '../types/WorkforceProfileTypes';
import type {ProfileComparisonFilterState} from '../utils/ProfileComparison/filterProfileComparisonProfiles';

const defaultFilters: ProfileComparisonFilterState = {
  search: '',
  seniority: null,
  alignmentTier: 'all',
};

export const useProfileComparisonFilters = (profiles: CompanyWorkforceProfile[]) => {
  const [filters, setFilters] = useState<ProfileComparisonFilterState>(defaultFilters);

  const seniorityOptions = useMemo(() => {
    const values = new Set(profiles.map((profile) => profile.seniority).filter(Boolean));
    return [...values].sort((a, b) => a.localeCompare(b));
  }, [profiles]);

  const hasActiveFilters =
    filters.search.trim().length > 0 || filters.seniority !== null || filters.alignmentTier !== 'all';

  const clearFilters = () => {
    setFilters(defaultFilters);
  };

  return {
    filters,
    setFilters,
    seniorityOptions,
    hasActiveFilters,
    clearFilters,
  };
};
